/**
 * Class to check and add a title to iframes on the page.
 *
 * This is mainly for Accessibility purposes and helps making sure iframes have some kind of title at least, even if its a very generic one.
 */
class Accordions {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', () => this.setUpAccordions() );
	}

	/**
	 * Checks all iframes on the page and adds a title if missing.
	 *
	 */
	setUpAccordions() {
		const accordionTabs = document.querySelectorAll( '.ac-module-accordion__wrapper .tab' );

		accordionTabs.forEach( tab => {
			tab.querySelectorAll( 'button' ).forEach( button => {
				button.addEventListener( 'click', () => {
					const contentId = button.getAttribute( 'aria-controls' );
					const content = document.getElementById( contentId );
					const isExpanded = button.getAttribute( 'aria-expanded' ) === 'true';

					button.setAttribute( 'aria-expanded', String( ! isExpanded ) );
					content.setAttribute( 'aria-hidden', String( isExpanded ) );
					tab.classList.toggle( 'active' );

					if ( isExpanded ) {
						content.setAttribute( 'inert', '' );
					} else {
						content.removeAttribute( 'inert' );
					}
				} );
			} );
		} );
	}
}

export default Accordions;
